import { __awaiter, __rest } from "tslib";
export class NodeCommand {
    constructor({ model }) {
        this.execute = (command, args) => __awaiter(this, void 0, void 0, function* () {
            return this[command](args);
        });
        this.model = model;
    }
    ADD_NODE(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges,
                    groups,
                    nodes: [...nodes, payload],
                };
            }, res);
        });
    }
    DELETE_NODE(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    nodes: nodes === null || nodes === void 0 ? void 0 : nodes.filter(node => payload !== node.id),
                    edges: edges === null || edges === void 0 ? void 0 : edges.filter(edge => payload !== edge.target && payload !== edge.source),
                    groups
                };
            }, res);
        });
    }
    BATCH_ADD_NODES(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges,
                    groups,
                    nodes: [...nodes, ...payload],
                };
            }, res);
        });
    }
    BATCH_DELETE_NODES(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    nodes: nodes === null || nodes === void 0 ? void 0 : nodes.filter(node => payload === null || payload === void 0 ? void 0 : payload.includes(node.id)),
                    edges: edges === null || edges === void 0 ? void 0 : edges.filter(edge => (payload === null || payload === void 0 ? void 0 : payload.findIndex(nodeId => edge.target === nodeId || edge.source === nodeId)) > -1),
                    groups
                };
            }, res);
        });
    }
}
//# sourceMappingURL=index.js.map